<template>
  <div>
    <v-card>
      <v-card-title>
        Responsables
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="search"
          label="Buscar"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="assemblies"
        :search="search"
        :loading="loadingTable"
      >
        <template slot="items" slot-scope="props">
          <td class="text-xs-center">{{ props.item.description }}</td>
          <td class="text-xs-center">{{ assistance_types[props.item.assistance_type] }}</td>
          <td class="text-xs-center">{{ props.item.name_as }}</td>
          <td class="text-xs-center">
            <v-tooltip top v-show="others.is_external==0">
              <v-icon
                medium
                class="mr-2"
                @click="addItem(props.item)"
                slot="activator"
              >
                add
              </v-icon>
              <span>Añadir agenda</span>

            </v-tooltip>
            <v-tooltip top v-show="others.is_external!=0">
              <v-icon
                medium
                class="mr-2"
                @click="requestSchedule(props.item)"
                slot="activator"
              >
                calendar_today
              </v-icon>
              <span>Solicitar agenda</span>

            </v-tooltip>
            <v-tooltip top v-show="others.is_external==0">
              <v-icon
                medium
                class="mr-2"
                @click="takeScheduleAssistance(props.item)"
                slot="activator"
              >
                assignment_turned_in
              </v-icon>
              <span>Tomar asistencia</span>

            </v-tooltip>
          </td>
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning">
          Your search for "{{ search }}" found no results.
        </v-alert>
      </v-data-table>
    </v-card>
    <div v-if="family.length > 0">
      <v-layout row justify-center v-if="step == 4">
        <v-btn color="primary" @click="goToPrevStep(3)">{{ $t(`enrollments.back`) }}</v-btn>
        <v-btn color="primary" @click="goToNextStep(5)">{{ $t(`enrollments.next`) }}</v-btn>
      </v-layout>
      <v-layout row justify-center v-else-if="step == 5">
        <v-btn color="primary" @click="goToPrevStep(4)">{{ $t(`enrollments.back`) }}</v-btn>
      </v-layout>
    </div>
    <v-dialog v-if="family.length > 0"
      v-model="detail_dialog"
      transition="dialog-transition"
    >
      <v-card>
        <available-schedule
          v-if="itemId"
          :responsible_id="itemId"
          :entry_id="family[0].id"
        ></available-schedule>
        <v-layout row justify-center>
            <v-btn
            @click="detail_dialog = false"
            color="primary">close</v-btn>
        </v-layout>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
    import axios from 'axios'
    import Form from 'vform';
    import availableSchedule from '~/pages/shedule/AvailableSchedules'

    export default {
        name: 'quotes-responsible-show',
        components: {
          'available-schedule': availableSchedule,
        },
        props: {
          family: {
            type: [Array],
            required: false,
            default: () => []
          },
          quote_id: {
            type: [String],
            required: false
          },
          step: {
            type: [String],
            required: false
          }
        },
        data() {
            return {
                others:[],
                search: '',
                headers: [
                    { text: 'Descripcion', align: 'center', value: 'description' },
                    { text: 'Tipo de cita', align: 'center', value: 'assistance_type' },
                    { text: 'Responsable', align: 'center', value: 'responsable_name' },
                    { text: 'Acción', align: 'center', value: 'id', sortable: false }
                ],
                assemblies: [],
                dialogIdAssembly: 0,
                dialog: false,
                userNameMaxLength: 60,
                entries: [],
                isLoading: false,
                currentMemberSearch: null,
                searchBoardMembers: null,
                boardMembersHeaders: [
                    { text: 'Actions', value: 'name', sortable: false, align: 'center' }
                ],
                boardMembers: [],
                boardMembersSearch: '',
                showCreateMemberForm: false,
                createMemberForm: new Form({
                    name: ''
                }),
                loadingTable: false,
                assistance_types: {
                  BOTH: 'Virtual y Presencial',
                  ONLINE: 'Virtual',
                  FACEFACE: 'Presencial'
                },
                detail_dialog: false,
                itemId: null
            }
        },
        created() {
            this.getShow()
        },
        methods: {
            async getShow() {
                this.loadingTable = true;
                const { data } = await axios.get('/quotes/responsable/show')
                let assemblies = data.data;
                this.others = data.others[0]
                if (this.family.length > 0) {
                  const quote_id = JSON.parse(this.quote_id)
                  const arrOfNum = quote_id.map(str => {
                    return parseInt(str, 10);
                  });
                  assemblies = assemblies.filter(ass => arrOfNum.includes(ass.quotes_id));
                }
                if (data.others[0].is_external!=0) {
                  assemblies = assemblies.filter(ass => ass.status == 0);
                }
                this.assemblies = assemblies
                this.loadingTable = false;
            },
            addItem(item) {
                this.$router.push({ name: 'shedule.create', params: {id: item.id}});
            },
            requestSchedule(item) {
              if (this.family.length > 0) {
                this.itemId = item.id
                this.detail_dialog = true
              } else {
                this.$router.push({ name: 'shedule.RequestSchedule', params: {id: item.id}});
              }
            },
            takeScheduleAssistance(item) {
                this.$router.push({ name: 'shedule.ScheduleTakeAssistance', params: {id: item.id}});
            },
            goToPrevStep(step) {
              this.$emit('goToPrevStep', step)
            },
            async goToNextStep(step) {
              this.$emit('goToNextStep', step, this.family)
            },
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/responsibleAppointment/showResponsibleQuote.vue